import React from 'react';
import empty from 'assets/images/empty.png';

export const Empty = () =>
    <div className={'flex flex-col items-center'}>
        <img src={empty} alt={'Empty'} />
        <p className={'text-base font-normal text-black-100'}>داده‌ای برای نمایش وجود ندارد!</p>
    </div>;
